<script>
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store";
import { useChatStore } from "@/store/chat.store";
import { defineComponent } from "vue";
import { API } from "@/api/api.ts";
import { ChatService } from "@/services/socket/chat.service.ts";

const api = new API();

export default defineComponent({
  name: "ChatMixin",
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    ...mapState(useChatStore, ["threads", "chatService"]),
  },
  methods: {
    async handleChatSocket(connection) {
      const chatStore = useChatStore();

      const chatService = new ChatService(connection);
      chatStore.setChatService(chatService);

      this.chatService.subscribe();
      await this.loadAllThreads();
    },
    disconnectChat() {
      if (this.chatService) {
        this.chatService.unsubscribe();
        this.chatService = null;
      }
    },
    showMessageTime(dt) {
      const d = this.$dayjs.utc(dt).tz(this.dispatcher.timezone);
      const isToday = d.isSame(new Date(), "day");
      return d.format(isToday ? "HH:mm z" : "MM/DD/YY HH:mm z");
    },
    async noResponseThread() {
      try {
        const resp = await api.chat.noResponseThread(this.thread.id);
        const chatStore = useChatStore();
        chatStore.updateThread(resp.data);
        this.updateMessages(this.thread);
      } catch (err) {
        console.error("Can not set no response thread", err);
      }
    },
    async resolveThread() {
      await this.updateThread({ dispatcherId: this.dispatcher.id, resolved: true });
    },
    updateMessages(thread, limit = 25, timeFrom = null) {
      if (!thread || !thread.id || !this.chatService) {
        return;
      }

      this.chatService.sendMessagesUpdate(thread.id, limit, timeFrom);
    },
    async updateThread(data) {
      try {
        const resp = await api.chat.updateThread(this.thread.id, data);
        const chatStore = useChatStore();
        chatStore.updateThread(resp.data);
        this.updateMessages(this.thread);
      } catch (err) {
        console.error("Can not update thread", err);
      }
    },
    async loadAllThreads() {
      let offset = 0;
      const chatStore = useChatStore();
      for (;;) {
        try {
          const resp = await api.chat.getThreads(offset, 300);
          if (resp.success) {
            if (resp.data.threads.length === 0) break;

            chatStore.addThreads(resp.data.threads);
            offset += resp.data.threads.length;
          } else {
            break;
          }
        } catch (e) {
          console.error("Can t update threads list", e);
          break;
        }
      }

      chatStore.sortThreads();
      chatStore.recalcThreadsCount();
    },
  },
});
</script>
